import { Dataset } from '../../../types/types';
import {
  getMultisortFromDataset,
  updateActiveSortingFromLazyState,
} from '../../../utils/managerUtils';
import { ExportLazyState } from '../types';

export const resolveSubsetSorting = (
  lazyState: ExportLazyState | undefined,
  subsetDataset: Dataset
): { field: string; order: number }[] => {
  const defaultSorting = getMultisortFromDataset(subsetDataset) || [];

  // Untouched subset grids carry an empty multiSortMeta, which must not shadow the default.
  return lazyState?.multiSortMeta?.length
    ? updateActiveSortingFromLazyState(defaultSorting, lazyState)
    : defaultSorting;
};
